export class Metadata {
  private title: string | null = null;
  private doi: string | null = null;

  public getTitle (): string | null {
    return this.title;
  }

  public setTitle (title?: string | null): this {
    this.title = title ?? null;

    return this;
  }

  public getDoi (): string | null {
    return this.doi;
  }

  public setDoi (doi?: string | null): this {
    this.doi = doi ?? null;

    return this;
  }
}
